export default __webpack_public_path__ + "static/media/tramitta-logo.5203b05a.png";